const value = {
    systems: 'Systems',
    skillsMap: 'Expertise map',
    unitSearch: 'Name of context or unit',
    showUnits: 'Show units',
    unitsFilter: {
      all: 'All',
      important: 'Mandatory',
      unimportant: 'Optional',
    },
    noUnits: 'No units available',
  };

export default value;
